import { useRef, useState, useEffect } from 'react'
import { Tooltip } from 'react-tooltip'
import './style.scss'

export default function DataAttributionTooltip() {
  const [showTooltip, setShowTooltip] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | number | null>(null)
  const isHoveringTooltip = useRef(false)
  const timeout = 300

  useEffect(() => {
    if (showTooltip) {
      const tooltipEl = document.getElementById('data-attribution-tooltip')
      if (tooltipEl == null) return

      const handleTooltipEnter = () => {
        isHoveringTooltip.current = true
        if (timeoutRef.current != null) {
          clearTimeout(timeoutRef.current)
        }
        setShowTooltip(true)
      }

      const handleTooltipLeave = () => {
        isHoveringTooltip.current = false

        timeoutRef.current = setTimeout(() => {
          if (!isHoveringTooltip.current) {
            setShowTooltip(false)
          }
        }, timeout)
      }

      tooltipEl.addEventListener('mouseenter', handleTooltipEnter)
      tooltipEl.addEventListener('mouseleave', handleTooltipLeave)

      return () => {
        tooltipEl.removeEventListener('mouseenter', handleTooltipEnter)
        tooltipEl.removeEventListener('mouseleave', handleTooltipLeave)
      }
    }
  }, [showTooltip])

  const handleMouseEnter = () => {
    if (timeoutRef.current != null) {
      clearTimeout(timeoutRef.current)
    }
    setShowTooltip(true)
  }

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      if (!isHoveringTooltip.current) {
        setShowTooltip(false)
      }
    }, timeout)
  }

  return (
    <div className="cst-data-attribution">
      <small
        className="data-attribution-info"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        Data sources
      </small>
      <Tooltip
        anchorSelect=".data-attribution-info"
        place="top-start"
        noArrow
        isOpen={showTooltip}
        id="data-attribution-tooltip"
      >
        <div>
          <p>
            <a
              href="https://fluxnet.org/data/fluxnet2015-dataset/"
              target="_blank"
              rel="noopener noreferrer"
            >
              FLUXNET2015
            </a>
            ,&nbsp; © FLUXNET,&nbsp;
            <a
              href="https://creativecommons.org/licenses/by/4.0/"
              target="_blank"
              rel="noopener noreferrer"
            >
              CC BY 4.0
            </a>
            ,
          </p>
          <p>
            <a
              href="https://ameriflux.lbl.gov/data/data-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              AmeriFlux
            </a>
            ,&nbsp; © AmeriFlux,&nbsp;
            <a
              href="https://creativecommons.org/licenses/by/4.0/"
              target="_blank"
              rel="noopener noreferrer"
            >
              CC BY 4.0
            </a>
            ,
          </p>
          <p>
            <a
              href="https://cds.climate.copernicus.eu/datasets/sis-agrometeorological-indicators"
              target="_blank"
              rel="noopener noreferrer"
            >
              AgERA5
            </a>
            ,&nbsp; © Copernicus,&nbsp;
            <a
              href="https://creativecommons.org/licenses/by/4.0/"
              target="_blank"
              rel="noopener noreferrer"
            >
              CC BY 4.0
            </a>
            ,
          </p>
          <p>
            <a
              href="https://www.usgs.gov/centers/eros/data-citation"
              target="_blank"
              rel="noopener noreferrer"
            >
              Landsat
            </a>
            ,&nbsp; © USGS, Public Domain
          </p>
        </div>
      </Tooltip>
    </div>
  )
}
